import { audienceSelectorStyle } from './audience-selector-style';
import type { CommonStylesPalette } from '../types.d';


export const adCustomizersStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .ac-container': {
    position: 'relative',
  },

  '& .ad-customizer-container > .dropdown-menu.picker-list': {
    maxHeight: 432,
    overflowY: 'auto',

    '& > li ~ li, & > .adcustomizerpicker-syntax-container ~ li': {
      borderTop: `1px solid ${palette.neutralSecondary}`,
    },

    '& > li > a': {
      fontSize: 14,
      height: 'auto',

      '& .type-bold': {
        fontWeight: 600,
      },
    },
  },

  '& .ac-helper-area.adCustomizersEditor': {
    background: 'white',
    borderRadius: 2,
    boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)',
    padding: '27px 32px 32px 32px',
    zIndex: 1090,
  },

  '& .ad-customizer-container > .dropdown-menu > .adcustomizerpicker-syntax-container': {
    padding: '27px 32px 16px 32px',

    '& ~ li > a': {
      padding: '0 32px',
    },

    '& .panel-heading': {
      padding: 'unset',
      border: 'none',
      borderRadius: 0,

      '& a': {
        display: 'inline-flex',
        padding: 0,
        width: 'auto',
      },
    },
  },

  '& div[data-type="Responsive"] .ad-customizer-container': {
    '& > .dropdown-menu.adCustomizersEditor, > .picker-list': {
      marginLeft: 32,
      marginTop: 66,
    },
  },

  '& .ad-customizer-container > .dropdown-menu.adCustomizersEditor': {
    fontSize: 14,
    lineHeight: '19px',

    '& .picker-content': {
      borderTop: `1px solid ${palette.neutralSecondary}`,
      padding: '16px 32px 32px 32px',

      '& .form-grid': {
        '& > .control-label': {
          display: 'flex',
          padding: 0,
          textAlign: 'left',

          '& ~ .control-label': {
            marginTop: 32,
          },

          '& label': {
            padding: '0 0 7px 0',
          },
        },

        '& > span': {
          display: 'block',
          alignSelf: 'center',
        },

        '& .checkbox label, .radio label': {
          paddingLeft: 0,
        },

        '& .form-buttons': {
          marginTop: 36,

          '& button.cancel': {
            marginLeft: 8,
          },
        },
      },

      '& .countdownEditor .form-grid': {
        display: 'grid',
        fallbacks: [
          {
            display: '-ms-grid',
          },
        ],
        gridTemplateColumns: '136px 136px 1fr',
        '-ms-grid-columns': '136px 136px 1fr',

        '& .form-label': {
          gridColumnStart: '1',
          gridColumnEnd: 'span 3',
          '-ms-grid-column': '1',
          '-ms-grid-column-span': '3',

          '&.flexible-grid-row-1': {
            '-ms-grid-row': '1',
          },

          '&.flexible-grid-row-4': {
            '-ms-grid-row': '5',
          },

          '&.flexible-grid-row-6': {
            '-ms-grid-row': '8',
          },

          '&.flexible-grid-row-7': {
            '-ms-grid-row': '10',
          },
        },

        '& .form-date': {
          gridColumnStart: '1',
          '-ms-grid-column': '1',
          '-ms-grid-row': '2',
          paddingRight: 12,
        },

        '& .form-time': {
          gridColumnStart: '2',
          '-ms-grid-column': '2',
          '-ms-grid-row': '2',
          paddingRight: 12,
        },

        '& .form-time-format': {
          gridColumnStart: '3',
          '-ms-grid-column': '3',
          '-ms-grid-row': '2',
        },

        '& .form-days': {
          gridColumnStart: '1',
          '-ms-grid-column': '1',
          '-ms-grid-row': '6',
          paddingRight: 12,
        },

        '& .form-days-description': {
          gridColumnStart: '2',
          gridColumnEnd: 'span 2',
          '-ms-grid-column': '2',
          '-ms-grid-column-span': '2',
          '-ms-grid-row': '6',
        },

        '& .form-time-zone': {
          gridColumnStart: '1',
          gridColumnEnd: 'span 3',
          '-ms-grid-column': '1',
          '-ms-grid-column-span': '3',
          '-ms-grid-row': '9',
        },

        '& .form-language': {
          gridColumnStart: '1',
          gridColumnEnd: 'span 3',
          '-ms-grid-column': '1',
          '-ms-grid-column-span': '3',
          '-ms-grid-row': '11',

          '& select': {
            minWidth: 180,
            width: 'fit-content',
          },
        },

        '& .form-buttons': {
          gridColumnStart: '1',
          gridColumnEnd: 'span 3',
          '-ms-grid-column': '1',
          '-ms-grid-column-span': '3',
          '-ms-grid-row': '13',
        },

        '& .form-validation': {
          gridColumnStart: '1',
          gridColumnEnd: 'span 3',
          '-ms-grid-column': '1',
          '-ms-grid-column-span': '3',

          '&.flexible-grid-row-2': {
            '-ms-grid-row': '3',
          },

          '&.flexible-grid-row-3': {
            '-ms-grid-row': '4',
          },

          '&.flexible-grid-row-5': {
            '-ms-grid-row': '7',
          },

          '&.flexible-grid-row-8': {
            '-ms-grid-row': '12',
          },
        },
      },

      '& .keyword-editor .form-grid': {
        display: 'flex',
        flexDirection: 'column',

        '& .form-default-text input': {
          width: 124,
        },
      },

      '& .k-select': {
        display: 'none',
      },

      '& .radio': {
        padding: 0,
      },

      '& .error': {
        color: '#A80000',
        listStyle: 'none',
        margin: 0,
        padding: 0,

        '& li': {
          paddingTop: 4,
        },
      },

      '& .default-value-input': {
        '& > .display-inline-block ~ .display-inline-block': {
          marginTop: 36,
        },

        '& .col-sm-4, & .col-sm-8': {
          display: 'flex',
          float: 'none',
          padding: 0,
          width: '100%',

          '& label': {
            padding: '0 0 7px 0',
          },

          '& input': {
            width: 124,
          },
        },

        '& input.btn-default': {
          marginLeft: 8,
        },
      },

      '& .iff-editor': {
        '& .panel-body': {
          position: 'static',
          overflow: 'hidden',
        },

        '& .iff-editor__label': {
          display: 'flex',

          '& ~ .iff-editor__label': {
            marginTop: 32,
          },

          '& label': {
            padding: '0 0 7px 0',
          },
        },

        '& .iff-editor__field': {
          display: 'flex',
          alignItems: 'baseline',

          '& input': {
            width: 220,
          },

          '& select': {
            width: 180,

            '& + span': {
              marginLeft: 11,
            },
          },
        },

        '& .iff-editor__buttons-group': {
          marginTop: 36,

          '& button ~ button': {
            marginLeft: 8,
          },
        },

        '& .iff-editor__field--audience-selector': {
          marginTop: 16,

          ...audienceSelectorStyle({ palette, iconFontFamily }),
        },
      },
    },
  },
});
